<template>
  <v-col cols="12">
    <v-row>
      <v-text-field
        v-model="copyOfForm.company_custom"
        v-validate="required.company"
        :label="mess['dialog_request_company']"
        outlined
        dense
        :error-messages="errors.collect('company')"
        data-vv-name="company"
      />
    </v-row>

    <v-row>
      <v-col cols="6" class="pa-0">
        <v-text-field
          v-model="copyOfForm.fio"
          v-validate="required.fio"
          :label="mess['dialog_request_fio']"
          outlined
          dense
          :error-messages="errors.collect('fio')"
          data-vv-name="fio"
        />
      </v-col>

      <v-col cols="6" class="pa-0 pl-3">
        <v-text-field
          v-model="copyOfForm.email"
          v-validate="required.email"
          :label="mess['dialog_request_email']"
          outlined
          dense
          :error-messages="errors.collect('email')"
          data-vv-name="email"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6" class="pa-0">
        <v-select
          :value="copyOfForm.country"
          :items="countries"
          :label="mess['dialog_request_countries']"
          item-text="name"
          outlined
          dense
          return-object
          @change="copyOfForm.country = $event.name"
        />
      </v-col>

      <v-col cols="6" class="pa-0 pl-3">
        <v-text-field
          v-model="copyOfForm.price_list"
          :label="mess['dialog_request_price_list']"
          outlined
          dense
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6" class="pa-0">
        <v-text-field
          v-model="copyOfForm.sales_chanel"
          :label="mess['dialog_request_sales_chanel']"
          outlined
          dense
        />
      </v-col>

      <v-col cols="6" class="pa-0 pl-3">
        <v-text-field
          v-model="copyOfForm.list_companies"
          v-validate="required.list_companies"
          :label="mess['dialog_request_list_of_companies']"
          outlined
          dense
          :error-messages="errors.collect('list_companies')"
          data-vv-name="list_companies"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-text-field
        v-model="copyOfForm.responsible_person"
        :label="mess['dialog_request_responsible_person']"
        outlined
        dense
      />
    </v-row>

    <v-row class="mb-4">
      <h3 class="ma-0 mb-3">
        {{ mess["dialog_request_restrictions"] }}
      </h3>
    </v-row>

    <v-col cols="12" class="pa-0 mb-4">
      <v-row class="pa-0 mb-2">
        <v-checkbox
          v-model="copyOfForm.show_contains_of_equipment"
          :hide-details="true"
          :label="mess['dialog_request_show_contains_of_equipment']"
          class="ma-0"
        />
      </v-row>

      <v-row class="pa-0 my-0">
        <v-col cols="4" class="pa-0">
          <v-checkbox
            v-model="copyOfForm.show_full_element_number"
            :hide-details="true"
            :label="mess['dialog_request_show_full_element_number']"
            class="ma-0"
          />
        </v-col>

        <v-col cols="4" class="pa-0">
          <v-checkbox
            v-model="copyOfForm.show_full_oem_number"
            :hide-details="true"
            :label="mess['dialog_request_show_full_oem_number']"
            class="ma-0"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-col>
</template>

<script>
import RequestForm from "@/mixins/RequestForm";
import { countries } from "@/constants/countries";

export default {
  name: "AddNewAccount",
  inject: ["$validator"],
  mixins: [RequestForm],
  data() {
    return {
      countries,
      copyOfForm: {
        show_contains_of_equipment: false,
        show_full_element_number: false,
        show_full_oem_number: false
      }
    };
  },
  computed: {
    errors() {
      return {};
    }
  }
};
</script>
